<template>
  <v-app id="liveapp">
    <template v-if="$route.path.indexOf('/editor') === -1 && $route.path.indexOf('/slide') === -1">
    <main-app-bar></main-app-bar>
    
      <router-view name="sidebar"></router-view>
    <!--<transition enter-active-class="animated fadeInLeft" leave-active-class="animated fadeOutLeft" v-if="drawer"></transition>-->
    <v-content class="content">
      <!--<transition enter-active-class="animated fadeInd" leave-active-class="animated fadeOudt"></transition-->
      <router-view />
      
    </v-content>

    </template>
    <template v-else>
      <router-view></router-view>
    </template>
    <v-snackbar :value="error" absolute :timeout="timeout" top color="error">
      {{ error }}
      <v-btn text @click="closeNotification">Close</v-btn>
    </v-snackbar>

    <!--v-snackbar
      v-model="emailreminder"
      absolute
      top
      color="success"
    >Please Verify your email address</v-snackbar-->
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MainAppBar from "@/components/MainAppBar";
import DefaultDrawer from "@/components/drawer";

export default {
  name: "App",
  components: {
    MainAppBar,
    DefaultDrawer
  },
  data: () => ({
    eventId: null,
    timeout: 0,
    items: [
      { title: "Dashboard", icon: "mdi-view-dashboard" },
      { title: "Photos", icon: "mdi-image" },
      { title: "About", icon: "mdi-help-box" }
    ],
    right: null
  }),
  methods: {
    ...mapActions("application", ["toggleLoading", "setError", "showDrawer"]),
    closeNotification() {
      this.setError(null);
      this.toggleLoading(false);
    }
  },
  computed: {
    ...mapState({
      user: state => state.application.user,
      error: state => state.application.error,
      loading: state => state.application.loading,
      updateAvailable: state => state.application.updateAvailable
    }),
    drawer: {
      get() {
        return this.$store.state.application.drawer;
      },
      set(val) {
        this.showDrawer(val);
      }
    },
    emailreminder: {
      get() {
        return (
          this.$store.state.application.user &&
          !this.$store.state.application.user.emailVerified
        );
      },
      set(val) {
        this.showDrawer(val);
      }
    }
  },
  created() {
    document.addEventListener("sw-updated", () => {
      alert("update avilable, app will be refreshed");
      window.location.reload(true);
    });
  }
};
</script>

<style>
html,
body,.liveapp {
  overflow: hidden !important;
}
</style>
